import { BreadcrumbItem, Breadcrumbs } from "@vds/breadcrumbs";
import { Button, TextLinkCaret } from "@vds/buttons";
import { Loader } from "@vds/loaders";
import { RadioButtonGroup } from "@vds/radio-buttons";
import { Title } from "@vds/typography";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { setCameraCaliration } from "../../api/RoiServiceManager";
import { RADIO_LABELS } from "../../constants/cameraInfoConstants";
import { HTTP_STATUS_CODES } from "../../global/constants/constants";
import {
  BackAndNextButtonsContainer,
  FrameForDataContainer,
  Image,
  ImageGrid,
  NameStreamGrayContainer,
  StreamDescriptiveText
} from "../../global/components/OnboardingFormStyles/Styles";
import { ImageDownloadMedia } from "../../model/mediaService";
import { saveStreamImageMapping, fetchAllDevices, refreshCameraPage } from "../../store/actions";
import AutomaticCalibrationModal from "./automaticCalibrationModal";
import { CAMERA_ONBOARDING_TEST_IDS } from "./cameraOnboardingConstants";
import ManualCalibration from "./manualCalibration";

const StreamCalibration = () => {
  const { state } = useLocation();
  const breadcrumbItem = state?.breadcrumbItem;
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const {
    camDetails,
    companionSelected,
    fovNames,
    fovIds,
    snapshots,
    selectedCameraQR,
    floorSelected,
    areaSelected,
    subAreaSelected,
    siteSelected,
    cameraName,
  } = useSelector((state) => state.cameraonboardingReducer);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [showStream3, setShowStream3] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isManual, setIsManual] = useState(false);
  const [selectedItemFovIds, setselectedItemFovIds] = useState([]);
  const [selectedItemFovImages, setSelectedItemFovImages] = useState([]);
  const [manualStreamName, setManualStreamName] = useState("");
  const [manualSnapshot, setManualSnapshot] = useState([]);

  const [farposition, setFarPosition] = useState([]);
  const [nearSize, setNearSize] = useState([]);
  const [farSize, setFarSize] = useState([]);
  const [manualCount, setmanualCount] = useState(0);
  const [manualDevices, setManualDevices] = useState([]);
  const [selectdeviceId, setSelectDeviceId] = useState("");
  const [selectName, setSelectName] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [banner, setBanner] = useState(false);
  const unpairedImages = useSelector(
    (state) => state.imagesReducer.unpairedImages
  );
  const [newSnapshotsList, setNewSnapshotsList] = useState([]);
  const { cameraList, fovList } = useSelector((state) => state?.deviceReducer);
  const [snapshotData, setSnapshotData] = useState([]);
  const [submitOptions, setSubmitOptions] = useState(true);

  const automaticCalibration = () => {
    setShowModal(true);
  };

  const isStaging = window.REACT_APP_ENV === "staging";

  const getFovNameFromId = (fovId) => {
    return fovList.find((item) => item.id === fovId).name;
  };

  const getReducerData = (fovId) => {
    return newSnapshotsList?.find((i) => i?.id === fovId);
  };

  // download fov image from id
  const downlaodSnapShotImage = (fovData, streamId) => {
    fovData?.length &&
      fovData?.forEach((fovItem) => {
        selectedItemFovIds.push(fovItem?.fovid);
        setIsLoading(false);
        ImageDownloadMedia(fovItem?.imageid, activeSession, streamId)
          .then((imageUrl) => {
            selectedItemFovImages.push(imageUrl);
            dispatch(
              saveStreamImageMapping(
                fovItem.fovid,
                imageUrl,
                fovItem.imagetimestamp
              )
            );
            const updatedData = {
              id: fovItem.fovid,
              name: getFovNameFromId(fovItem.fovid),
              imageUrl: imageUrl,
              timestamp: fovItem.imagetimestamp,
            };

            setSnapshotData((prevItems) => [...prevItems, updatedData]);
          })
          .catch((error) => {
            console.error("Error downloading snapshot:", error);
            const reducerData = getReducerData(fovItem?.fovid);
            if (
              reducerData &&
              !snapshotData.some((i) => i.id === fovItem?.fovid)
            ) {
              setSnapshotData((prevItems) => [...prevItems, reducerData]);
            }
          })
          .finally(() => {
            setSelectedItemFovImages(selectedItemFovImages);
            setselectedItemFovIds(selectedItemFovIds);
            setIsLoading(false);
          });
      });
  };

  useEffect(() => {
    if (snapshotData) {
      setNewSnapshotsList(snapshotData);
    }
  }, [snapshotData]);

  const handleInitialSelection = () => {
    let selectedItemsList = [];
    if (fovNames.length > 1) {
      fovNames?.forEach((item) => {
        selectedItemsList.push(item?.fovId + "-automatic");
      });
    }
    setSelectedOptions(selectedItemsList);
  };

  useEffect(() => {
    handleInitialSelection();
  }, []);

  const handleNext = async (count = 0) => {
    const operations = [];
    let payload = {};
    if (selectedOptions.length === 0) {
      selectedOptions.push(`${fovNames[0]?.fovId}-automatic`);
      setSelectedOptions(selectedOptions);
    }
    if (selectedOptions.length) {
      const allSkip = selectedOptions.every((option) =>
        option.includes("skipStreamCalibration")
      );
      const manual = selectedOptions.some((option) =>
        option.includes("-manual")
      );
      if (manual && manualDevices && manualCount < manualDevices.length) {
        setSelectDeviceId(manualDevices[manualCount]);
        setSelectName(manualSnapshot[manualCount]?.name);
        setmanualCount(count + 1);
        setIsManual(true);
      } else if (allSkip) {
        navigate("/devices");
      } else {
        setIsLoading(true);
        selectedOptions.forEach((option) => {
          if (
            option &&
            (option.includes("-automatic") || option.includes("-manual"))
          ) {
            let deviceid;
            let config;
            if (option.includes("-automatic")) {
              deviceid = option.split("-automatic")[0];
            } else {
              deviceid = option.split("-manual")[0];
              const farpositionM = farposition.filter((f) => f.id === deviceid);
              const farSizeM = farSize.filter((f) => f.id === deviceid);
              const nearSizeM = nearSize.filter((f) => f.id === deviceid);
              config = {
                farposition: farpositionM[0]?.farposition
                  ? farpositionM[0]?.farposition
                  : 100,
                sceneparameters: {
                  far_size: farSizeM[0]?.farSize ? farSizeM[0]?.farSize : 1,
                  near_size: nearSizeM[0]?.nearSize
                    ? nearSizeM[0]?.nearSize
                    : 1,
                },
              };
            }
            payload = {
              accountname: activeSession.accountname,
              resources: [
                {
                  fovidentifier: {
                    deviceid: deviceid,
                  },
                  config,
                },
              ],
            };
            operations.push(setCameraCaliration(payload, activeSession));
          }
        });
      }
    }
    if (operations.length > 0) {
      try {
        const response = await Promise.any(operations);
        if (response === HTTP_STATUS_CODES.OK || response === HTTP_STATUS_CODES.ACCEPT) {
          setBanner(true);
        }
        setShowStream3(true);
      } catch (error) {
        console.error("Error calibrating camera:", error);
      }
    }
    // dispatch(calibrateCamera(payload));

    // setShowStream3(true);
  };

  const handleIntialSnapshots = (fovNames) => {
    const newSnapshotsList = fovNames
      ?.map((item) => {
        const match = unpairedImages.find((i) => i.id === item.fovId);
        if (match) {
          return {
            id: item.fovId,
            name: item.fovName,
            imageUrl: match.imageUrl,
            timestamp: match.timestamp,
          };
        }
        return null;
      })
      .filter((f) => f !== null);
    setNewSnapshotsList(newSnapshotsList);
  };

  useEffect(() => {
    handleIntialSnapshots(fovNames);
    // const cameraIdofSelectedCam = cameraList
    //   ?.filter((item) => item?.qrcode === selectedCameraQR)
    //   .map((obj) => obj.id);
    // const fovsList = fovList
    //   ?.filter((item) => item?.parentdeviceid === cameraIdofSelectedCam[0])
    //   .map((obj) => obj.id);
    // if (companionSelected?.qrcode) {
    //   setIsLoading(true);
    //   fovsList?.forEach((fov) => {
    //     getPairedCamSnapShotIds(activeSession, selectedCameraQR, fov)
    //       .then((fovData) => {
    //         downlaodSnapShotImage(fovData);
    //       })
    //       .catch((err) => console.log(err))
    //       .finally(() => setIsLoading(false));
    //   });
    // }
  }, [cameraList, selectedCameraQR]);

  useEffect(() => {
    const manual = selectedOptions.some((option) => option.includes("-manual"));
    if (selectedOptions.length && manual) {
      setSubmitOptions(false);
    } else {
      setSubmitOptions(true);
    }
  }, [selectedOptions]);

  const handleRadioChange = (value, index, name, image) => {
    if (value.includes("-manual")) {
      const deviceid = value.split("-manual")[0];
      if (!manualDevices.includes(deviceid)) {
        manualDevices.push(deviceid);
        setManualDevices(manualDevices);
      }
      //setIsManual(true);
      setManualStreamName(value.split("-manual")[0]);
      manualSnapshot.push({
        id: value.split("-manual")[0],
        name: name,
        imageurl: image,
      });
      setManualSnapshot(manualSnapshot);
    } else {
      if (value.split("-automatic")[0]) {
        const arr = manualDevices.filter(
          (item) => item !== value.split("-automatic")[0]
        );
        setManualDevices(arr);
        setManualSnapshot(
          manualSnapshot.filter((f) => f.id !== value.split("-manual")[0])
        );
      }
      setIsManual(false);
    }
    setSelectedOptions(prev => {
      const updated = [...prev];
      updated[index] = value;
      return updated;
    });
  };

  const calibrationOption = (item, index) => {
    const options = [
      {
        children: "Automatic",
        value: `${item?.id}-automatic`,
        ariaLabel: "radio one",
        disabled: false,
      },
    ];

    const manualCalibrationOption = {
      children: item?.imageUrl ? "Manual" : RADIO_LABELS.MANUAL_NO_SNAPSHOT,
      value: `${item?.id}-manual`,
      ariaLabel: "radio two",
      disabled: !item?.imageUrl,
    };
    options.splice(1, 0, manualCalibrationOption);
    return options;
  };

  const handleBack = () => {
    if (isManual) {
      let count = manualCount > 0 ? manualCount - 1 : 0;
      setmanualCount(count);
      if (count === 0) {
        setIsManual(false);
        setSelectDeviceId([]);
        setManualDevices([]);
        setManualSnapshot([]);
        setSelectName("");
      }
      if (manualDevices.length === manualCount) {
        count = count - 1;
      }
      setSelectDeviceId(manualDevices[count]);
      setSelectName(manualSnapshot[count]?.name);
    } else {
      navigate("/devices");
    }
  };
  return (
    <>
      {!showStream3 ? (
        <div>
          {isLoading && <Loader fullscreen={true} active={isLoading} disableFocusLock />}

          <Breadcrumbs surface="light">
            <BreadcrumbItem>
              <Link
                data-testid="streanCalibration_CamerasDevicesLink"
                to="/devices"
                className="breadcrums-item_link"
              >
                Cameras
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem>{breadcrumbItem}</BreadcrumbItem>
            <BreadcrumbItem>Stream calibration</BreadcrumbItem>
          </Breadcrumbs>
          <br></br>
          <FrameForDataContainer
            className={`d-flex justify-content-center align-items-center w-100`}
          >
            {!isManual && (
              <div style={{ marginLeft: "-17%" }} className="w-50">
                <Title size="medium">Stream Calibration</Title>
              </div>
            )}
            {!isManual && (
              <NameStreamGrayContainer>
                <StreamDescriptiveText>
                  Stream calibration helps improve the accuracy of your computer
                  vision apps. We can automatically calibrate your streams or
                  you can calibrate manually. <br /> <br /> Note: Automatic
                  calibration works best when there are people in various
                  locations of the stream’s view or if there is a single person
                  moving around to different points within the stream’s view.{" "}
                  <a
                    style={{ textDecoration: "underLine" }}
                    onClick={automaticCalibration}
                    data-testid={CAMERA_ONBOARDING_TEST_IDS.AUTOMATIC_CALIBRATION_LINK}
                  >
                    See example
                  </a>
                </StreamDescriptiveText>
                <div className="vision-stream-calibration-snapshot">
                  {newSnapshotsList &&
                    newSnapshotsList.map((item, index) => (
                      <div className="vision-stream-calibration-snapshot-item">
                        <ImageGrid>
                          <>
                            {item.imageUrl && (
                              <Image
                                key={index}
                                src={
                                  item.imageUrl
                                    ? item.imageUrl
                                    : "./assets/sample.png"
                                }
                                alt="Loading..."
                              />
                            )}
                          </>
                        </ImageGrid>
                        <Title size="small">{item?.name}</Title>
                        <br />

                        <RadioButtonGroup
                          value={selectedOptions[index] || ""}
                          onChange={(e) =>
                            handleRadioChange(
                              e.target.value,
                              index,
                              item.name,
                              item.imageUrl
                                ? item.imageUrl
                                : "./assets/sample.png"
                            )
                          }
                          data-testid={CAMERA_ONBOARDING_TEST_IDS.STREAM_CALIBRATION_RADIO_GROUP}
                          error={false}
                          data={calibrationOption(item, index)}
                        />
                      </div>
                    ))}
                </div>
              </NameStreamGrayContainer>
            )}

            {isManual && (
              <div>
                {/* style={{ border: "1px solid black", borderRadius: "2%" }} <div style={{ fontSize: "13px", color: "red", padding: "10px", textAlign: "center", margin: "0 auto" }}>
                      Stream <span style={{ fontWeight: "550" }}>{manualStreamName} </span>   will be calibrated automatically as manual calibration is still under progress.
                    </div> */}
                <ManualCalibration
                  setFarPosition={setFarPosition}
                  farposition={farposition}
                  deviceid={selectdeviceId}
                  farSize={farSize}
                  setFarSize={setFarSize}
                  nearSize={nearSize}
                  setNearSize={setNearSize}
                  imageUrl={manualSnapshot}
                  selectName={selectName}
                />
              </div>
            )}

            <BackAndNextButtonsContainer>
              <TextLinkCaret
                surface="light"
                onClick={() => {
                  dispatch(refreshCameraPage(true));
                }}
                data-testid={CAMERA_ONBOARDING_TEST_IDS.STREAM_CALIBRATION_BACK_BUTTON}
              >
                Skip
              </TextLinkCaret>
              <Button
                onClick={() => {
                  handleNext(manualCount);
                }}
                data-testid={CAMERA_ONBOARDING_TEST_IDS.STREAM_CALIBRATION_NEXT_BUTTON}
                size="large"
                use="primary"
              >
                {manualCount < manualDevices.length ? "Next" : "Submit"}
              </Button>
            </BackAndNextButtonsContainer>

            <AutomaticCalibrationModal
              showModal={showModal}
              setShowModal={setShowModal}
            />
          </FrameForDataContainer>
        </div>
      ) : (
        navigate(`/devices`, {
          state: {
            banner: banner,
          },
        })
      )}
    </>
  );
};

export default StreamCalibration;
